var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classIntroductionBox"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.profile)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }